module.exports = __webpack_public_path__ + "img/dsg.0debca5f.svg";